import { createContext, useContext } from "react";
var context = createContext(false);
if (process.env.NODE_ENV !== "production") {
    context.displayName = "TableFooterContext";
}
/**
 * @private
 */
export var TableFooterProvider = context.Provider;
/**
 * @private
 */
export function useTableFooter() {
    return useContext(context);
}
//# sourceMappingURL=footer.js.map